import { Card } from '@/components/ui/Card';
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';

export type AttendanceTrendGraphPoint = {
  label: string;
  present?: number;
  absent?: number;
  rate?: number;
  percentage?: number;
};

export function AttendanceTrendGraph({
  title,
  caption,
  data,
  isLoading,
}: {
  title: string;
  caption?: string;
  data?: AttendanceTrendGraphPoint[] | null;
  isLoading?: boolean;
}) {
  const chartData = (data ?? []).map((point) => ({
    ...point,
    rate: point.rate ?? point.percentage ?? 0,
  }));

  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-lg font-bold text-slate-800">{title}</h3>
        {caption ? <p className="text-sm text-slate-500">{caption}</p> : null}
      </div>
      {isLoading ? (
        <div className="h-64 animate-pulse rounded-xl bg-slate-50" />
      ) : chartData.length === 0 ? (
        <p className="py-12 text-center text-sm text-slate-400">No attendance to graph yet</p>
      ) : (
        <div className="h-64 w-full" data-testid="attendance-trend-graph">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={chartData} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="label" tick={{ fontSize: 12 }} />
              <YAxis yAxisId="left" tick={{ fontSize: 12 }} />
              <YAxis yAxisId="right" orientation="right" domain={[0, 100]} tick={{ fontSize: 12 }} unit="%" />
              <Tooltip />
              <Legend />
              <Bar yAxisId="left" dataKey="present" name="Present" fill="#10b981" radius={[4, 4, 0, 0]} />
              <Bar yAxisId="left" dataKey="absent" name="Absent" fill="#f43f5e" radius={[4, 4, 0, 0]} />
              <Line yAxisId="right" type="monotone" dataKey="rate" name="Rate %" stroke="#4f46e5" strokeWidth={2} dot={false} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
